import React, { useState, useEffect, useMemo } from "react";
import "./styles/theme.css";
import "./App.css";
import Dashboard from "./components/Dashboard";
import HomePage from "./components/homepage/HomePage";
import ResetPasswordPage from "./components/auth/ResetPasswordPage";

function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkAuthStatus();
    }, []);

    const checkAuthStatus = () => {
        const token = localStorage.getItem('token');
        const userData = localStorage.getItem('user');
        
        if (token && userData) {
            setUser(JSON.parse(userData));
        }
        setLoading(false);
    };

    const isResetRoute = useMemo(() => window.location.pathname === "/reset-password", []);

    if (isResetRoute) {
        return (
            <div className="app">
                <ResetPasswordPage />
            </div>
        );
    }

    const handleLogin = (userData, token) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
    };

    if (loading) {
        return (
            <div className="app">
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="app">
            {user ? (
                <Dashboard user={user} onLogout={handleLogout} />
            ) : (
                <HomePage onLogin={handleLogin} />
            )}
        </div>
    );
}

export default App;
